// Search
export const SEARCH_PAGE_VIEW = 'searchPageView';
export const SEARCH_PAGE_CLICKTHROUGH = 'searchPageClickthrough';
export const SEARCH_SORT_CLICK = 'sortSearchClick';
export const SEARCH_FACET_CLICK = 'facetClick';
export const TOGGLE_DESKTOP_FACETS = 'toggleDesktopFacets';
export const TOP_BANNER_AD_CLICK = 'advertisementClick';
export const TOP_BANNER_AD_IMPRESSION = 'advertisementImpressionWrapper';
export const SEARCH_PILL_GROUP_TOGGLE = 'facetAttributeDropdownClick';
export const SEARCH_SHOW_MORE_TOGGLE = 'facetAttributeShowMoreClick';
export const SEARCH_SWATCH_INTERACTION = 'swatchInteraction';

// Header
export const TOP_LEVEL_NAV_CLICK = 'topLevelNavigationClick';
export const EXPLICIT_SEARCH = 'explicitSearch';
export const NAVIGATION_CLICK = 'navigationClick';
export const STORE_SELECTOR_EVENT = 'storeSelectorEvent';

// Landing
export const HOME_PAGE_VIEW = 'homePageView';
export const LANDING_PAGE_VIEW = 'landingPageView';

// PDP
export const PRODUCT_PAGE_VIEW = 'productPageView';
export const SIZING_IMPRESSION = 'sizingImpression';
export const PRODUCT_ACCORDION_EVENT = 'productAccordionEvent';
export const PRODUCT_BADGES_EVENT = 'productBadgesEvent';
export const PRODUCT_SOCIAL_ICON_EVENT = 'productSocialIconEvent';
export const PRODUCT_GENDER_EVENT = 'productGenderEvent';
export const PRODUCT_COUNTRY_UNIT_EVENT = 'productCountryUnitEvent';
export const PRODUCT_IMAGE_THUMBNAIL_EVENT = 'productImageThumbnailEvent';
export const PRODUCT_FEATURED_ZOOM_EVENT = 'productFeaturedZoomEvent';
export const PRODUCT_ZOOM_IN_EVENT = 'productZoomInEvent';
export const PRODUCT_ZOOM_OUT_EVENT = 'productZoomOutEvent';

// Cart
export const CART_ADD = 'addToCart';
export const CART_PAGE_VIEW = 'cartPageView';
export const PROCEED_TO_CHECKOUT = 'proceedToCheckout';

// Account
export const ADD_TO_COLLECTIONS = 'addToCollections';

// Checkout
export const PAYMENT_SECTION = 'PAYMENT_SECTION';
export const SHIPPING_SECTTION = 'SHIPPING_SECTION';
export const BILLING_ADDRESS_SECTION = 'BILLING_ADDRESS_SECTION';

// Influencer
export const INFLUENCER_ENROLLMENT_EVENTS = 'influencer_enrollment_events';
export const INFLUENCER_SIGNUP_EVENTS = 'influencer_signup_events';
export const INFLUENCER_CHECKOUT_PAGE_EVENTS = 'influencer_checkout_page_events';
export const INFLUENCER_CREATE_SHARE_LINK_EVENTS = 'influencer_create_share_link_events';
export const INFLUENCER_LANDING_EVENTS = 'influencer_landing_events';
export const INFLUENCER_ADD_SOCIAL_PROFILE_CLICK = 'influencer_add_social_profile_click';

// Media Source
export const INSTAGRAM_MEDIA_SOURCE = 'INSTAGRAM';
export const UNKNOWN_MEDIA_SOURCE_TYPE = 'UNKNOWN_MEDIA_SOURCE_TYPE';

// Pixel
export const PIXEL_EVENT = 'pixel_event';
